import { GameCommunicationConnectionObserver } from './GameCommunicationConnectionObserver';
import {
  GameHFCommunicationGameResultProcessor,
  GameCommunicationLeaderBoardProcessor,
  GameCommunicationManStatisticHistoryProcessor,
  GameComunicationStartDealingProcessor,
  GameCommunicationTimerProcessor,
  GameComunicationAutoCashOutWinProcessor,
  GameCommunicationWinProcessor,
  GameCommunicationSeatProcessor,
} from './processors';
import { GameCommunicationCrashGameProcessor } from './processors/GameCommunicationCrashGameProcessor';
import { GameCommunicationHFBetProcessor } from './processors/GameCommunicationHFBetProcessor';
import { GameCommunicationHFBetsOpenProcessor } from './processors/GameCommunicationHFBetsOpenProcessor';
import { GameCommunicationHFBetsProcessor } from './processors/GameCommunicationHFBetsProcessor';
import { GameCommunicationHFSwitchProcessor } from './processors/GameCommunicationHFSwitchProcessor';
import { GameCommunicationMultiplierProcessor } from './processors/GameCommunicationMultiplierProcessor';
import { GameComunicationCancelledBetProcessor } from './processors/GameComunicationCancelledBetProcessor';
import { GameComunicationCashOutErrorProcessor } from './processors/GameComunicationCashOutErrorProcessor';
import { GameComunicationCashOutProcessor } from './processors/GameComunicationCashOutProcessor';
import { GameComunicationGameCanceledProcessor } from './processors/GameComunicationGameCanceledProcessor';
import { GameComunicationGameCancledMulProcessor } from './processors/GameComunicationGameCancledMulProcessor';
import { GameHFCommunicationBetsClosedProcessor } from './processors/GameHFCommunicationBetsClosedProcessor';
import { GameCommunicationBetSender } from './senders';
import { GameCommunicationCashOutSender } from './senders/GameCommunicationCashOutSender';
import { GameCommunicationKeepAliveSender } from './senders/GameCommunicationKeepAliveSender';

export const highflyerGameCommunicationControllerConfig = {
  processors: [
    GameHFCommunicationGameResultProcessor,
    GameCommunicationLeaderBoardProcessor,
    GameCommunicationManStatisticHistoryProcessor,
    GameComunicationStartDealingProcessor,
    GameCommunicationTimerProcessor,
    GameCommunicationHFBetsOpenProcessor,
    GameHFCommunicationBetsClosedProcessor,
    GameCommunicationCrashGameProcessor,
    GameCommunicationMultiplierProcessor,
    GameComunicationCancelledBetProcessor,
    GameComunicationCashOutErrorProcessor,
    GameComunicationGameCanceledProcessor,
    GameComunicationGameCancledMulProcessor,
    GameComunicationCashOutProcessor,
    GameComunicationAutoCashOutWinProcessor,
    GameCommunicationHFBetProcessor,
    GameCommunicationWinProcessor,
    GameCommunicationHFBetsProcessor,
    GameCommunicationSeatProcessor,
    GameCommunicationHFSwitchProcessor,
  ],
  senders: [
    new GameCommunicationBetSender(),
    new GameCommunicationCashOutSender(),
    new GameCommunicationKeepAliveSender(),
  ],
  connectionObserver: new GameCommunicationConnectionObserver(),
};

export const getKeepAliveSender = (): GameCommunicationKeepAliveSender =>
  highflyerGameCommunicationControllerConfig.senders.find(
    (s) => s instanceof GameCommunicationKeepAliveSender
  ) as GameCommunicationKeepAliveSender;